import React from 'react';
import { Tag, type TagProps } from 'antd';

/**
 * Единая палитра: заявки, маршруты, агрегаты (не фин. обязательства/задачи — там свои теги).
 * Неизвестный код: «—» (без сырого английского).
 */
export const STATUS_MAP = {
  CREATED: { color: 'default' as const, label: 'Создан' },
  IN_PROGRESS: { color: 'blue' as const, label: 'В работе' },
  IN_TRANSIT: { color: 'blue' as const, label: 'В пути' },
  READY_FOR_COMPLETION: { color: 'cyan' as const, label: 'Готов к завершению' },
  ISSUES: { color: 'red' as const, label: 'Проблемы' },
  COMPLETED: { color: 'green' as const, label: 'Завершён' },
  CANCELLED: { color: 'default' as const, label: 'Отменён' },
  OVERDUE: { color: 'red' as const, label: 'Просрочено' },
  OPEN: { color: 'red' as const, label: 'Не оплачено' },
  PARTIAL: { color: 'orange' as const, label: 'Частично' },
  PARTIALLY_PAID: { color: 'orange' as const, label: 'Частично оплачено' },
  OK: { color: 'green' as const, label: 'Оплачено' },
  PAID: { color: 'green' as const, label: 'Оплачено' },
  NO_INVOICE: { color: 'default' as const, label: 'Нет счёта' },
  PENDING: { color: 'default' as const, label: 'Ожидает' },
  NOT_PAID: { color: 'default' as const, label: 'Не оплачено' },
  EXPECTED: { color: 'orange' as const, label: 'Ожидает' },
  SATISFIED: { color: 'green' as const, label: 'Выполнено' },
  CLOSED: { color: 'default' as const, label: 'Закрыто' },
} as const;

export type EntityStatusKey = keyof typeof STATUS_MAP;

const STATUS_ALIASES: Record<string, EntityStatusKey> = {
  IN_WORK: 'IN_PROGRESS',
  UNPAID: 'OPEN',
  SUCCESS: 'OK',
};

function resolveKey(raw: string | null | undefined): EntityStatusKey | undefined {
  if (raw == null || raw === '') return undefined;
  const u = String(raw).toUpperCase();
  if (u in STATUS_MAP) return u as EntityStatusKey;
  return STATUS_ALIASES[u];
}

/** Текст статуса для подписей в модалках/фильтрах (без JSX). */
export function getStatusLabel(status: string | null | undefined): string {
  const key = resolveKey(status);
  if (key == null) return '—';
  return STATUS_MAP[key].label;
}

export type StatusTagProps = Omit<TagProps, 'color' | 'children'> & {
  status?: string | null | undefined;
};

export const StatusTag: React.FC<StatusTagProps> = ({ status, ...rest }) => {
  const key = resolveKey(status);
  const cfg = key != null ? STATUS_MAP[key] : undefined;
  const label = cfg != null ? cfg.label : '—';
  const color = cfg?.color ?? 'default';
  return (
    <Tag color={color} {...rest}>
      {label}
    </Tag>
  );
};

export default StatusTag;
